var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"custom_bg"},[(_vm.$route.meta.showHeader == true)?_c('NavBar',{staticClass:"d-print-none"}):_vm._e(),_c('v-main',[_c('v-slide-x-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }